module.exports = __webpack_public_path__ + "static/media/Cotizador1.cb92b225.png";